import "./main.scss"

import "blissfuljs"
import BigPicture from "bigpicture"
import { Gallery } from "./js/gallery"
import { initHelpButton } from "./js/helpButton"
import { initInteractions } from "./js/interactions"
import { Masonry } from "./js/masonry"
import { Navigation } from "./js/navigation"
import { OverlayHandler } from "./js/overlayHandler"
import { ScrollMenu } from "./js/scroll-menu"
import { SelfTest } from "./js/selftest"
import { ToggleElements } from "./js/toggleElements"

const Parallax = require("parallax-js")

import smoothscroll from "smoothscroll-polyfill"

smoothscroll.polyfill()

window.htmx = require("htmx.org")
const htmx = window.htmx

const $ = window.Bliss
const $$ = $.$

$.ready().then(() => {
  // Init parallax

  const scene = document.querySelectorAll(".parallax-scene")
  if (scene) {
    for (const s of scene) new Parallax(s)
  }

  // Init forms

  const appearForms = $$("[data-appear-form]")

  const observeForms = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.intersectionRatio > 0) {
        for (const el of entry.target.querySelectorAll("[data-form]")) {
          el.style.animation = `${entry.target.dataset.appear} .8s ${
            Math.random() * 3
          }s forwards ease-out`
        }
      }
    }
  })

  function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min
  }

  if (appearForms) {
    for (const entry of appearForms) {
      const sectionHeight = entry.getBoundingClientRect().height

      let forms = []
      if (sectionHeight < 600) {
        forms = [1]
      } else if (sectionHeight > 600 && sectionHeight < 1000) {
        forms = [1, 1]
      } else {
        forms = [1, 1, 1]
      }

      for (const _ of forms) {
        entry.appendChild(
          $.create({
            tag: "span",
            class: "section--form",
            "data-form": entry.dataset.themeForm,
          }),
        )
      }

      observeForms.observe(entry)
      const form = entry.querySelectorAll("[data-form]")

      const maxSize = 20
      const minSize = 5

      for (const el of form) {
        const size = getRandomArbitrary(minSize, maxSize)
        el.style.left = `${Math.random() * 80}%`
        el.style.top = `${Math.random() * 80}%`
        el.style.width = `${size}rem`
        el.style.height = `${size}rem`
      }
    }
  }

  // Init interactions

  initInteractions()

  // Toggle
  new Navigation()
  new ToggleElements()

  // Overlay Handler

  const overlay = $("[data-overlay]")

  if (overlay) {
    new OverlayHandler(overlay)
  }

  initHelpButton()

  // selftest

  const selftest = $("[data-selftest]")

  if (selftest) {
    new SelfTest(selftest)
  }

  // Gallery

  const questionGallery = $$(".question-slider:not(.gallery--none)")
  if (questionGallery) {
    for (const e of questionGallery) {
      new Gallery(e, {
        interval: 5000,
        autoPlay: false,
        createThumbs: true,
        endless: false,
        visibleSlides: 1,
      })
    }
  }

  const newsGallery = $$(".news-slider:not(.gallery--none)")
  if (newsGallery) {
    for (const e of newsGallery) {
      new Gallery(e, {
        interval: 5000,
        autoPlay: true,
        createThumbs: true,
        endless: false,
        visibleSlides: 1,
      })
    }
  }

  // Masonry
  function doMasonryLayout(parent) {
    for (const gridEl of parent.querySelectorAll("[data-masonry]"))
      new Masonry(gridEl, gridEl.getAttribute("data-masonry"))
  }
  doMasonryLayout(document)

  // cta teasers hover effect
  const counsellingTeaserLeft = $(".counselling-teaser--left")
  const counsellingTeaserRight = $(".counselling-teaser--right")
  const counsellingTeasersWrapper = $(".counselling-teasers--wrapper")
  // let dataCounsellingAnchor = $$("[data-counselling-anchor]")
  //
  // if (dataCounsellingAnchor) {
  //   dataCounsellingAnchor.forEach(el => {
  //     el.addEventListener("click", e => {
  //       console.log(e);
  //     })
  //     // el.addEventListeners('click', e => {
  //     //   console.log(e);
  //     // })
  //   })
  // }
  const mediaQuery = window.matchMedia("(min-width: 750px)")

  if (mediaQuery.matches && counsellingTeaserRight) {
    counsellingTeaserRight.addEventListener("mouseover", () => {
      counsellingTeasersWrapper.setAttribute("data-active", "2")
    })

    counsellingTeaserLeft.addEventListener("mouseover", () => {
      counsellingTeasersWrapper.setAttribute("data-active", "1")
    })
  }

  // center list
  function checkCenterList() {
    const centerList = document.querySelector("[data-center-list]")
    const centerListCanton = document.querySelector("[data-center-list-canton]")
    const centerListMap = document.querySelector(".center-list--map")

    if (centerList) {
      const canton = document.querySelector("#id_canton", centerList)
      const cantonName = document.querySelector("option:checked", canton)

      if (cantonName.value) {
        centerListMap.classList.add(
          cantonName.innerHTML
            .toLowerCase()
            .replace(/\s+/g, "-")
            .replace(/[^\w-]+/g, ""),
        )
        // alert(cantonName.innerHTML.toLowerCase().replace(/\s+/g, '-'))

        if (centerListCanton) {
          centerListCanton.parentElement.classList.remove("hide")
          centerListCanton.innerText = `«${cantonName.innerHTML}»`
        }
      } else if (centerListCanton) {
        centerListCanton.parentElement.classList.add("hide")
      }
    }
  }
  checkCenterList()

  // Scroll menu

  const linkList = $$("[data-link]")
  const targetList = $$("[data-anchor]")

  if (targetList) {
    new ScrollMenu({
      links: linkList,
      offsetMediaQueries: [
        {
          mediaQuery: "(min-width: 1024px)",
          scrollOffset: -150,
          rootMargin: "-100px 0px 0px 0px",
        },
        {
          mediaQuery: "(min-width: 768px)",
          scrollOffset: -50,
          rootMargin: "-50px 0px 0px 0px",
        },
        {
          mediaQuery: "(min-width: 0px)",
          scrollOffset: -50,
          rootMargin: "200px 0px -100px 0px",
        },
      ],
      targets: targetList,
    })
  }

  //image popup

  const imagePopup = $$("[data-image-popup]")

  function openImage(e) {
    BigPicture({
      el: e.target,
      dimensions: [1280, 720],
    })
  }
  if (imagePopup) {
    for (const image of imagePopup) {
      image.addEventListener("click", (e) => {
        e.preventDefault()
        openImage(e)
      })
    }
  }

  // video popup

  const videoPopup = $$("[data-video-popup]")

  function openVideo(e) {
    BigPicture({
      el: e.target,
      autoplay: true,
      vidSrc: e.target.dataset?.videoSrc,
      ytSrc: e.target.dataset?.ytSrc,
      dimensions: [1280, 720],
      ytNoCookie: true,
    })
  }
  if (videoPopup) {
    for (const video of videoPopup) {
      video.addEventListener("click", (e) => {
        e.preventDefault()
        openVideo(e)
      })
    }
  }

  function regionMapClickable() {
    const form = document.querySelector(".center-list--filter-form")
    const cantones = document.getElementById("svg-map__cantones")
    const select = document.getElementById("id_canton")
    const centerListMap = $(".center-list--map")

    function resetClass() {
      const previousSelection = centerListMap.classList[1] || false
      if (previousSelection) centerListMap.classList.remove(previousSelection)
    }

    if (select) select.addEventListener("change", resetClass)

    if (cantones) {
      cantones.addEventListener("click", (e) => {
        const target = e.target
        const targetRegion = target.getAttribute("data-region")
        const targetClass = target.classList[1]
        resetClass()
        centerListMap.classList.add(targetClass)
        select.value = targetRegion
        htmx.trigger(form, "change")
      })
    }
  }

  htmx.onLoad((el) => {
    checkCenterList()
    regionMapClickable()
    doMasonryLayout(el)
  })

  regionMapClickable()

  /* Search highlighting */
  if (window.location?.hash.startsWith("#sq__")) {
    const searchText = window.location.hash.replace(/^#sq__/, "")

    const walker = document.createTreeWalker(
      document.querySelector("#content"),
      NodeFilter.SHOW_TEXT,
      null,
      false,
    )

    let node
    let first
    while ((node = walker.nextNode())) {
      const text = node.nodeValue
      const index = text.toLowerCase().indexOf(searchText.toLowerCase())
      if (index >= 0) {
        const span = document.createElement("span")
        span.classList.add("search-string")
        span.textContent = text.substring(index, index + searchText.length)
        const beforeText = text.substring(0, index)
        const afterText = text.substring(index + searchText.length)
        node.nodeValue = beforeText
        node.parentNode.insertBefore(span, node)
        node.nodeValue = afterText
        if (!first && (first = true)) {
          span.scrollIntoView({ behavior: "smooth" })
          const target = span.closest("[data-toggle-element]")
          if (target) {
            const trigger = target.querySelector("[data-toggle-trigger]")
            if (trigger) {
              const event = new MouseEvent("click", {
                view: window,
                bubbles: true,
                cancelable: true,
              })
              trigger.dispatchEvent(event)
            }
          }
        }
      }
    }
  }
})
